import axios from "axios";
const config = require(`../../environment/development`).config;
let cancelToken;
let cancelTokenForOrderFetch;


export const changeShippingAddressForSO = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(
        `${config.backEnd}/admin/change-shipping-address-for-so`,
        data,
        { headers: header }
      );
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const fetchFilteredQuotes = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelToken != typeof undefined) {
        // Previous api calls are cancelled
        cancelToken.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };

      cancelToken = axios.CancelToken.source();

      const response = await axios.get(`${config.backEnd}/admin/fetch-filtered-quotes`, {
        cancelToken: cancelToken.token,
        headers,
        params: data,
      });
      return resolve(response.data);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request cancelled', error.message);
      }
      return reject(error);
    }
  });
};

export const fetchQuotesForRefIdSearch = (token, refId) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelToken != typeof undefined) {
        // Previous api calls are cancelled
        cancelToken.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      cancelToken = axios.CancelToken.source();

      let response = await axios.get(
        `${config.backEnd}/admin/get-quotes-for-ref-id-search/${refId}`,
        {
          headers,
          cancelToken: cancelToken.token
        },
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};


export const getSalesOrdersForAllQuotation = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(`${config.backEnd}/admin/get-sales-order-for-all-quote`, {
        headers,
        params: data,
      });
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
}



export const fetchDashboardDataForMake = (token, filterData) => {
  return new Promise(async (resolve, reject) => {
    cancelTokenForOrderFetch && cancelTokenForOrderFetch.cancel();
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      cancelTokenForOrderFetch = axios.CancelToken.source();
      let response = await axios.get(`${config.backEnd}/admin/get-dashboard-data-make`, {
        headers: header,
        params: filterData,
        cancelToken: cancelTokenForOrderFetch.token,
      });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const getIssuesForSalesOrder = (token, orderId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(`${config.backEnd}/admin/get-issue-for-sales-order/${orderId}`, {
        headers: header,
      });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};


export const createInvoice = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(
        `${config.backEnd}/admin/create-invoice`,
        data,
        { headers: header }
      );
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const deleteDraftInvoice = (token, invoiceId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.delete(
        `${config.backEnd}/admin/delete-draft-invoice/${invoiceId}`,
        { headers }
      );
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const sendInvoiceToCustomer = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(
        `${config.backEnd}/admin/send-invoice-to-customer/`, data,
        { headers }
      );
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const getDetailsForInvoiceDetailsPage = (token, invoiceId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${config.backEnd}/admin/data-for-invoice-details/${invoiceId}`,
        { headers }
      );

      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const changeInvoiceAdminOwner = (token, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        'Authorization': `Bearer ${JSON.parse(token)}`,
        'Content-Type': 'application/json'
      }

      let response = await axios.post(`${config.backEnd}/admin/change-invoice-admin-owner`, payload, { headers: header });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};


export const fetchInvoiceForInvoiceNumberSearch = (token, invoiceNumber) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelToken != typeof undefined) {
        // Previous api calls are cancelled
        cancelToken.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      cancelToken = axios.CancelToken.source();

      let response = await axios.get(
        `${config.backEnd}/admin/get-invoice-for-invoice-number-search/${invoiceNumber}`,
        {
          headers,
          cancelToken: cancelToken.token
        },
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};


export const fetchFilteredInvoices = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelToken != typeof undefined) {
        // Previous api calls are cancelled
        cancelToken.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };

      cancelToken = axios.CancelToken.source();

      const response = await axios.get(`${config.backEnd}/admin/fetch-filtered-invoices`, {
        cancelToken: cancelToken.token,
        headers,
        params: data,
      });
      return resolve(response.data);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request cancelled', error.message);
      }
      return reject(error);
    }
  });
};



export const updateInvoiceQualityDoc = async (data, tokn) => {
  try {
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-Type': 'application/json'
    }
    let response = await axios.post(`${config.backEnd}/admin/update/invoice/qualitydoc`, data, { headers: header }).then(res => {
      return res
    }).catch(err => {
      return err
    })
    return response
  } catch (error) {
    return error
  }
}


export const invoiceConsignMentPictureUpload = async (data, tokn) => {
  try {
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-Type': 'application/json'
    }
    let response = await axios.post(`${config.backEnd}/admin/update/invoice/consignmentPhoto`, data, { headers: header }).then(res => {
      return res
    }).catch(err => {
      return err
    })
    return response
  } catch (error) {
    return error
  }
}


export const invoiceDeliveryLinkUpdate = async (tokn, data) => {
  try {
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-type': 'application/json'
    }

    let response = await axios.post(`${config.backEnd}/admin/update/invoice/deliveryLink`, data, { headers: header }).then(res => {
      return res
    }).catch(err => {
      return err
    })
    return response;
  } catch (error) {
    return error
  }
}


export const invoiceShippingDateUpdate = async (tokn, data) => {
  try {
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-type': 'application/json'
    }
    let response = await axios.put(`${config.backEnd}/admin/invoice/shipped-date`, data, { headers: header }).then(res => {
      return res
    }).catch(err => {
      return err
    })
    return response;
  } catch (error) {
    return error
  }
}


export const invoiceDeliveryDateUpdate = async (tokn, data) => {
  try {
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-type': 'application/json'
    }
    let response = await axios.put(`${config.backEnd}/admin/invoice/delivery-date`, data, { headers: header }).then(res => {
      return res
    }).catch(err => {
      return err
    })
    return response;
  } catch (error) {
    return error
  }
}


export const fetchFilteredOrders = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelTokenForOrderFetch != typeof undefined) {
        // Previous api calls are cancelled
        cancelTokenForOrderFetch.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };

      cancelTokenForOrderFetch = axios.CancelToken.source();

      const response = await axios.get(`${config.backEnd}/admin/fetch-filtered-orders`, {
        cancelToken: cancelTokenForOrderFetch.token,
        headers,
        params: data,
      });
      return resolve(response.data);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request cancelled', error.message);
      }
      return reject(error);
    }
  });
};


export const markInvoiceAsPaid = async (tokn, data) => {
  try {
    console.log("tone", tokn)
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-type': 'application/json'
    }
    let response = await axios.put(`${config.backEnd}/admin/invoice-mark-paid`, data, { headers: header }).then(res => {
      return res.data
    }).catch(err => {
      return err
    })

    return response;
  } catch (error) {

    return error
  }
}

export const approveInvoice = async (tokn, data) => {
  try {
    console.log("tone", tokn)
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-type': 'application/json'
    }
    let response = await axios.put(`${config.backEnd}/admin/approve-invoice`, { id: data }, { headers: header }).then(res => {
      return res.data
    }).catch(err => {
      return err
    })

    return response;
  } catch (error) {

    return error
  }
}


export const downloadDeliveryDocketForInvoice = async (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        'Authorization': `Bearer ${JSON.parse(token)}`,
        'Content-Type': 'application/json'
      }
      let response = await axios.post(`${config.backEnd}/admin/download-delivery-docket-invoice`, data, { headers: header }, { responseType: 'blob' });
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
}

export const sendInvoiceShippingEmail = async (tokn, data) => {
  try {
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-type': 'application/json'
    }
    let response = await axios.post(`${config.backEnd}/admin/mail/invoice-shipping-update`, data, { headers: header }).then(res => {
      return res
    }).catch(err => {
      return err
    })
    return response.data
  } catch (error) {
    return error
  }
}

export const sendInvoiceDeliveryEmail = async (tokn, data) => {
  try {
    let header = {
      'Authorization': `Bearer ${JSON.parse(tokn)}`,
      'Content-type': 'application/json'
    }
    let response = await axios.post(`${config.backEnd}/admin/mail/invoice-delivery-update`, data, { headers: header })
    return response.data;
  } catch (error) {
    return error
  }
}


export const fetchOrdersForRefIdSearch = (token, refId) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelToken != typeof undefined) {
        // Previous api calls are cancelled
        cancelToken.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      cancelToken = axios.CancelToken.source();

      let response = await axios.get(
        `${config.backEnd}/admin/get-orders-for-ref-id-search/${refId}`,
        {
          headers,
          cancelToken: cancelToken.token
        },
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const fetchAttachSalesOrders = (token, salesOrderIdArr) => {
  return new Promise(async (resolve, reject) => {
    try {
      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(
        `${config.backEnd}/admin/fetch-attach-sales-orders`,
        { salesOrderIdArr },
        { headers },
      );

      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};


export const fetchInvoiceForSalesRefSearch = (token, salesRef) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelToken != typeof undefined) {
        // Previous api calls are cancelled
        cancelToken.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      cancelToken = axios.CancelToken.source();


      let response = await axios.get(
        `${config.backEnd}/admin/get-invoice-for-sales-ref-search/${salesRef}`,
        {
          headers,
          cancelToken: cancelToken.token
        },
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const fetchInvoiceForPONumberSearch = (token, poNumber) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof cancelToken != typeof undefined) {
        // Previous api calls are cancelled
        cancelToken.cancel();
      }

      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      cancelToken = axios.CancelToken.source();


      let response = await axios.get(
        `${config.backEnd}/admin/get-invoice-for-po-number-search/${poNumber}`,
        {
          headers,
          cancelToken: cancelToken.token
        },
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const fetchQuotationDataForRFQ = (token, quotationIdArr) => {
  return new Promise(async (resolve, reject) => {
    try {
      let headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(
        `${config.backEnd}/admin/fetch-quotations-for-rfqs`,
        { quotationIdArr },
        { headers },
      );

      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const FileUploadInQuote = async (token, formData) => {
  console.log(token, formData);
  try {
    const response = await axios.post(`${config.backEnd}/admin/upload-files-quotes`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${JSON.parse(token)}`,
      }
    });
    return response.data;

  } catch (error) {
    return false;
  }
}

export const FileDeleteQuote = async (token, data) => {
  try {
    const response = await axios.delete(`${config.backEnd}/admin/delete-files-quote`, {
      data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JSON.parse(token)}`,
      }
    });
    return response.data;

  } catch (error) {
    return false;
  }
};

export const updatePartsData = async (token, data) => {
  try {
    const response = await axios.put(`${config.backEnd}/admin/update-parts-data`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JSON.parse(token)}`,
      }
    });
    return response.data;

  } catch (error) {
    return false;
  }

}